import React, { useContext } from "react";

import { Icon } from "@culturehq/components";

import { ElementSource } from "chq";
import { Trans } from "app/utils";
import AccessibleFocusOutlineElement from "components/common/AccessibleFocusOutlineElement";
import { CreatomateContext } from "../contexts/VideoStudioContext";

interface TemplatesButtonProps {
  mediaElements?: ElementSource[];
}

const TemplatesButton: React.FC<TemplatesButtonProps> = ({ mediaElements }) => {
  const { data } = useContext(CreatomateContext);
  const { activeMenuItem } = data;

  return (
    <AccessibleFocusOutlineElement tag="button" className="chq-btn" disabled={mediaElements?.length === 0}>
      <Icon
        className="ac_icon"
        icon={activeMenuItem === "templates" ? "layout-filled" : "layout"}
      />
      <Trans>Templates</Trans>
    </AccessibleFocusOutlineElement>
  );
};

export default TemplatesButton;
